/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminCouponDto,
  AdminCouponRequestDto,
  AdminUserCouponDto,
  AdminUserCouponRequestDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminCouponService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminCouponService
   * @name GetCoupon
   * @summary Get Coupon by ID
   * @request GET:/v1/admin/coupons/{couponId}
   * @secure
   */
  getCoupon = (couponId: number, params: RequestParams = {}) =>
    this.http.request<AdminCouponDto, any>({
      path: `/v1/admin/coupons/${couponId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name UpdateCoupon
   * @summary Update Coupon
   * @request PUT:/v1/admin/coupons/{couponId}
   * @secure
   */
  updateCoupon = (couponId: number, data: AdminCouponRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminCouponDto, any>({
      path: `/v1/admin/coupons/${couponId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name DeleteCoupon
   * @summary Delete Coupon
   * @request DELETE:/v1/admin/coupons/{couponId}
   * @secure
   */
  deleteCoupon = (couponId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/coupons/${couponId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name UpdateUserCoupon
   * @summary Update User Coupon
   * @request PUT:/v1/admin/coupons/{couponId}/user-coupons/{userCouponId}
   * @secure
   */
  updateUserCoupon = (
    couponId: number,
    userCouponId: number,
    data: AdminUserCouponRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminUserCouponDto, any>({
      path: `/v1/admin/coupons/${couponId}/user-coupons/${userCouponId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name DeleteUserCoupon
   * @summary Delete User Coupon
   * @request DELETE:/v1/admin/coupons/{couponId}/user-coupons/{userCouponId}
   * @secure
   */
  deleteUserCoupon = (couponId: number, userCouponId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/coupons/${couponId}/user-coupons/${userCouponId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name GetCoupons
   * @summary Get Coupons
   * @request GET:/v1/admin/coupons
   * @secure
   */
  getCoupons = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminCouponDto[], any>({
      path: `/v1/admin/coupons`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name CreateCoupon
   * @summary Create Coupon
   * @request POST:/v1/admin/coupons
   * @secure
   */
  createCoupon = (data: AdminCouponRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminCouponDto, any>({
      path: `/v1/admin/coupons`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name AssignUserCoupon
   * @summary Assign User Coupon
   * @request POST:/v1/admin/coupons/{couponId}/user-coupons/{userCouponId}/assign
   * @secure
   */
  assignUserCoupon = (
    couponId: number,
    userCouponId: number,
    query?: {
      username?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminUserCouponDto, any>({
      path: `/v1/admin/coupons/${couponId}/user-coupons/${userCouponId}/assign`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name ExportUserCoupons
   * @summary Export User Coupons
   * @request POST:/v1/admin/coupons/{couponId}/user-coupons/export
   * @secure
   */
  exportUserCoupons = (couponId: number, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v1/admin/coupons/${couponId}/user-coupons/export`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name CreateUserCoupons
   * @summary Create Multiple User Coupons
   * @request POST:/v1/admin/coupons/{couponId}/user-coupons/bulk-create
   * @secure
   */
  createUserCoupons = (
    couponId: number,
    query: {
      /** @format int32 */
      quantity: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/admin/coupons/${couponId}/user-coupons/bulk-create`,
      method: 'POST',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name UpdateCouponStatus
   * @summary Update User Coupon Status
   * @request PATCH:/v1/admin/coupons/{couponId}/user-coupons/{userCouponId}/status
   * @secure
   */
  updateCouponStatus = (
    couponId: number,
    userCouponId: number,
    query: {
      status: 'OPEN' | 'USED' | 'DISCARDED';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminUserCouponDto, any>({
      path: `/v1/admin/coupons/${couponId}/user-coupons/${userCouponId}/status`,
      method: 'PATCH',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name UpdateCouponRemark
   * @summary Update User Coupon Remark
   * @request PATCH:/v1/admin/coupons/{couponId}/user-coupons/{userCouponId}/remark
   * @secure
   */
  updateCouponRemark = (
    couponId: number,
    userCouponId: number,
    query: {
      remark: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminUserCouponDto, any>({
      path: `/v1/admin/coupons/${couponId}/user-coupons/${userCouponId}/remark`,
      method: 'PATCH',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCouponService
   * @name GetUserCouponsByCoupon
   * @summary Get User Coupons
   * @request GET:/v1/admin/coupons/{couponId}/user-coupons
   * @secure
   */
  getUserCouponsByCoupon = (
    couponId: number,
    query?: {
      /** @format int64 */
      userId?: number;
      listingIds?: number[];
      status?: 'OPEN' | 'USED' | 'DISCARDED';
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminUserCouponDto[], any>({
      path: `/v1/admin/coupons/${couponId}/user-coupons`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
